export enum TicketType {
  Incident = 0,
  Request = 1,
}

export const ticketTypes = [
  {
    id: TicketType.Incident,
    name: "Incident",
  },
  {
    id: TicketType.Request,
    name: "Cerere",
  },
];
